module.exports = __webpack_public_path__ + "static/media/rewards-return.60efc4ed.svg";